import React, {useState} from "react"
import { useNavigate } from "react-router-dom"
import { discoveryMiiDescriptions } from "../defaults"
import logoMii from '../../assets/images/mmiilogo.png'


const DiscoveryMii = (props) => {
    const { hoveredDiscoveryMiiPage, handleDiscoveryMiiMiiHoverToggle } = props
    const [hoveredDiscoveryMii, setHoveredDiscoveryMii] = useState(false);
    const navigate = useNavigate()

    const handleHovering = (isHovered) => {
        handleDiscoveryMiiMiiHoverToggle(isHovered)
        setHoveredDiscoveryMii(isHovered)
    }

    return (
        <div className="discoveryMii-container">
            <div className="flex flex-col h-full">
                <div className="flex flex-row h-3/6">
                    <div className="flex-1 p-4 text-center">
                        <div className="flex h-full justify-center items-center ">
                            <img className="object-contain h-3/6 w-3/6 " src={logoMii} alt="HRIS"/>
                        </div>
                    </div>
                    <div className="flex-1 self-center p-4">
                        <div className="h-3/6  rounded overflow-hidden shadow-lg">
                            <div className="px-6 py-4">
                                <div className="font-bold text-3xl text-homepage-label mb-5">{discoveryMiiDescriptions.label}</div>
                                <p className="text-gray-700 text-l">
                                    {discoveryMiiDescriptions.description}
                                    {/* <br/><br/>
                                    {discoveryMiiDescriptions.description2} */}
                                </p>
                                <p className="text-gray-700 text-xl">
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-row p-12 text-center">
                    <div className="flex-1 self-center p-4">
                    {/* <button
                            className={`text-white-700 bg-blue-500 py-2 px-8 rounded-md ${
                                hoveredBuildMii ? "bg-blue-700" : ""
                            }`}
                            onMouseEnter={() => setHoveredBuildMii(true)}
                            onMouseLeave={() => setHoveredBuildMii(false)}
                            onClick={() => navigate("/BuildMii/Form2")}
                            >
                                BuildMii a JD 2
                    </button> */}
                    </div>
                    <div className="flex-1 self-center p-4">
                        <button
                            className={`text-homepage-discoverymii-btntxt bg-homepage-discoverymii-btnbg py-2 px-8 rounded-full ${
                                hoveredDiscoveryMii ? "bg-blue-700" : ""
                            }`}
                            onMouseEnter={() => handleHovering(true)}
                            onMouseLeave={() => handleHovering(false)}
                            onClick={() => navigate("/DiscoveryMii/Form")}
                            >
                                Watchout
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DiscoveryMii
